<template>
  <div class="fitwrapper">
    <div class="center">
      <div v-if="!isAuthenticated" class="login-warning">
        <p class="login-message">{{ $t('common.please_login') }}</p>
        <button @click="goToLogin" class="login-button">{{ $t('common.login') }}</button>
      </div>

      <template v-else>
        <UserBmi />

        <FitHeader
          v-if="!selectedDay"
          :month="currentMonth"
          :year="currentYear"
          :monthNames="monthNames"
          @prev-month="prevMonth"
          @next-month="nextMonth"
        />

        <FitMonth
          v-if="!selectedDay"
          :year="currentYear"
          :month="currentMonth"
          @day-selected="selectedDay = $event"
        />

        <FitDay
          v-if="selectedDay"
          :day="selectedDay"
          :month="currentMonth"
          :year="currentYear"
          @back="selectedDay = null"
        />
      </template>
    </div>
  </div>
</template>
 
<script>
import FitDay from './FitDay.vue';
import FitHeader from './FitHeader.vue';
import FitMonth from './FitMonth.vue';
import UserBmi from './UserBmi.vue';

export default {
  components: { FitMonth, FitHeader, FitDay, UserBmi },
  data() {
    const today = new Date();
    return {
      isAuthenticated: false,
      currentYear: today.getFullYear(),
      currentMonth: today.getMonth(),
      selectedDay: null
    };
  },
  computed: {
    monthNames() {
      return this.$tm('noahfit.months');
    }
  },
  created() {
    const token = localStorage.getItem('token');
    this.isAuthenticated = !!token;
  },
  methods: {
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonth -= 1;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      } else {
        this.currentMonth += 1;
      }
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

  
  
  <style scoped>
  .fitwrapper {
    width: 90%;  
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .center {
   width: 100%; 
   max-width: 1080px;
  }
  
  @media (min-width: 768px) {
    .calendar-wrapper {
      max-width: 1080px;
      margin: 0 auto;
    }
  } 

  .login-warning {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem; 
  border-radius: 8px;
  color: #fff;
}

.login-button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #106E35;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.login-button:hover {
  background-color: #1CC655;
}

.login-message {
  font-size: 1rem;
}
</style>